import { api } from 'common';
import MaterialTable from 'material-table';
import { useTranslation } from "react-i18next";
import { colors } from '../components/Theme/WebTheme';
import { useSelector, useDispatch } from "react-redux";
import { downloadCsv } from '../common/sharedFunctions';
import React, { useState, useEffect, useRef } from 'react';
import CircularLoading from "../components/CircularLoading";
import { mainSignUp } from 'common/src/actions/authactions';

export default function Users() {
  const loaded = useRef(false);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [data, setData] = useState([]);
  const settings = useSelector(state => state.settingsdata.settings);
  const staticusers = useSelector(state => state.usersdata.staticusers);
  const {
    editUser,
    deleteUser,
    checkUserExists,
    fetchUsersOnce
  } = api;


  useEffect(() => {
    dispatch(fetchUsersOnce());
  }, [dispatch, fetchUsersOnce]);

  useEffect(() => {
    if (staticusers) {
      setData(staticusers.filter(user => user.usertype === 'admin'));
    } else {
      setData([]);
    }
    loaded.current = true;
  }, [staticusers]);

  const columns = [
    { title: t('first_name'), field: 'firstName', initialEditValue: '', cellStyle: { paddingLeft: 15 } },
    { title: t('last_name'), field: 'lastName', initialEditValue: '', cellStyle: { paddingLeft: 15 } },
    // { title: t('mobile'), field: 'mobile', editable: 'onAdd', render: rowData => settings.AllowCriticalEditsAdmin ? rowData.mobile : "Hidden for Demo" },
    { title: t('email'), field: 'email', editable: 'onAdd', render: rowData => settings.AllowCriticalEditsAdmin ? rowData.email : "Hidden for Demo", headerStyle: { textAlign: 'center' } },
    { title: t('password'), field: 'password', editable: 'onAdd', initialEditValue: '', cellStyle: { paddingLeft: 15 } },
  ];

  const [selectedRow, setSelectedRow] = useState(null);

  return (
    !loaded.current ? <CircularLoading /> :
      <MaterialTable
        data={data}
        columns={columns}
        title={t('alladmin')}
        style={{ borderRadius: "8px", boxShadow: "4px 4px 6px #9E9E9E" }}
        onRowClick={((evt, selectedRow) => setSelectedRow(selectedRow.tableData.id))}
        options={{
          exportCsv: (columns, data) => {
            let hArray = [];
            const headerRow = columns.map(col => {
              if (typeof col.title === 'object') {
                return col.title.props.text;
              }
              hArray.push(col.field);
              return col.title;
            });
            const dataRows = data.map(({ tableData, ...row }) => {
              row.createdAt = new Date(row.createdAt).toLocaleDateString() + ' ' + new Date(row.createdAt).toLocaleTimeString()
              let dArr = [];
              for (let i = 0; i < hArray.length; i++) {
                dArr.push(row[hArray[i]]);
              }
              return Object.values(dArr);
            })
            const { exportDelimiter } = ",";
            const delimiter = exportDelimiter ? exportDelimiter : ",";
            const csvContent = [headerRow, ...dataRows].map(e => e.join(delimiter)).join("\n");
            const csvFileName = 'download.csv';
            downloadCsv(csvContent, csvFileName);
          },
          exportButton: {
            csv: settings.AllowCriticalEditsAdmin,
            pdf: false,
          },
          maxColumnSort: "all_columns",
          rowStyle: rowData => ({
            backgroundColor: (selectedRow === rowData.tableData.id) ? '#EEE' : '#FFF'
          }),
          editable: {
            backgroundColor: colors.Header_Text,
            fontSize: "0.8em",
            fontWeight: 'bold ',
            fontFamily: 'Lucida Console", "Courier New", monospace'
          },
          headerStyle: {
            position: "sticky",
            top: "0px",
            backgroundColor: colors.Header,
            color: '#fff',
            fontSize: "0.8em",
            fontWeight: 'bold ',
            fontFamily: 'Lucida Console", "Courier New", monospace'
          }
        }}
        localization={{
          body: {
            addTooltip: (t('add')),
            deleteTooltip: (t('delete')),
            editTooltip: (t('edit')),
            emptyDataSourceMessage: (
              (t('blank_message'))
            ),
            editRow: {
              deleteText: (t('delete_message')),
              cancelTooltip: (t('cancel')),
              saveTooltip: (t('save'))
            },
          },
          toolbar: {
            searchPlaceholder: (t('search')),
            exportTitle: (t('export')),
          },
          header: {
            actions: (t('actions'))
          },
          pagination: {
            labelRowsPerPage: 'Linhas por página',
            labelDisplayedRows: ('{from}-{to} ' + (t('of')) + ' {count}'),
            firstTooltip: (t('first_page_tooltip')),
            previousTooltip: (t('previous_page_tooltip')),
            nextTooltip: (t('next_page_tooltip')),
            lastTooltip: (t('last_page_tooltip'))
          },
        }}
        editable={{
          onRowAdd: newData =>
            new Promise((resolve, reject) => {
              setTimeout(() => {
                checkUserExists(newData).then((res) => {
                  if (res.users && res.users.length > 0) {
                    alert(t('user_exists'));
                    reject();
                  }
                  else if (!(newData && newData.firstName)) {
                    alert(t('proper_input_name'));
                    reject();
                  }
                  if (!newData.password) {
                    alert('Selecione uma senha!');
                    reject();
                    return;
                  }
                  else {
                    checkUserExists(newData).then((res) => {
                      if (res.error) {

                        console.error(res.error);
                        alert(res.error.message);
                        reject();
                      }
                      else {
                        newData['usertype'] = 'admin';
                        newData['createdAt'] = new Date().getTime();

                        mainSignUp(newData).then((res) => {
                          dispatch(fetchUsersOnce());
                          resolve();
                        }).catch((error) => {
                          alert(error);
                          reject();
                        })
                      }
                    });
                  }
                });
              }, 600);
            }),
          onRowUpdate: (newData, oldData) =>
            new Promise((resolve, reject) => {
              setTimeout(() => {
                if (!(newData && newData.firstName)) {
                  alert(t('proper_input_name'));
                  reject();
                } else {
                  resolve();
                  if (newData !== oldData) {
                    delete newData.tableData;
                    dispatch(editUser(oldData.id, newData));
                    dispatch(fetchUsersOnce());
                  }
                }
              }, 600);
            }),
          onRowDelete: oldData =>
            settings.AllowCriticalEditsAdmin ?
              new Promise(resolve => {
                setTimeout(() => {
                  resolve();
                  if (oldData.id === 'admin0001') {
                    alert(t('first_admin_deleted'));
                  } else {
                    dispatch(deleteUser(oldData.id));
                    dispatch(fetchUsersOnce());
                  }
                }, 600);
              })
              :
              new Promise(resolve => {
                setTimeout(() => {
                  resolve();
                  alert(t('demo_mode'));
                }, 600);
              })
          ,
        }}
      />
  );
}
